import { Route } from "react-router-dom";
import React from "react";
import AuthWrapper from "./AuthWrapper";
import MentorRouteErrorBoundary from "../../components/common/MentorRouteErrorBoundary";


const getRoutes = (allRoutes) =>
  allRoutes.map(({ path, key, page, private: isPrivate }) => {
    const protectedPage = isPrivate ? <AuthWrapper>{page}</AuthWrapper> : page;
    const Element = <MentorRouteErrorBoundary>{protectedPage}</MentorRouteErrorBoundary>;

    return <Route path={path} element={Element} key={key} />;
  });

export default getRoutes;
